<template>
  <div>
    <v-card class="py-5" flat color="#E5E5E5">
      <div>
        <div class="px-10">
          <div class="d-flex justify-center mb-5">
            <span> <b> Type</b></span>
          </div>
          <div class="slide-toggle d-flex">
            <div class="boxes" @click="Presential = false">Presential</div>
            <div class="boxes" @click="Presential = true">Online</div>
            <div
              class="box-active animated"
              :class="{ 'presential-active': Presential }"
            ></div>
          </div>
        </div>
        <div class="mt-9" v-if="!Presential">
          <div class="px-10">
            <v-text-field
              label="Location Title"
              dense
              single-line
              hide-details
            ></v-text-field>
            <v-text-field
              class="my-8"
              label="Location Address"
              single-line
              dense
              hide-details
            ></v-text-field>
            <v-select
              v-model="Modality"
              single-line
              dense
              hide-details
              :items="ModalityList"
              label="Instructor"
              multiple
              persistent-hint
            ></v-select>
            <div class="d-flex justify-end mt-4">
              <span class="primary--text">Add new Instructor</span>
            </div>
            <v-select
              :items="items"
              label="Coordinator"
              single-line
              hide-details
              class="my-2"
            ></v-select>
            <v-select
              :items="items"
              label="Language"
              single-line
              hide-details
              class="my-2"
            ></v-select>
            <v-select
              :items="items"
              label="Status"
              single-line
              hide-details
              class="my-2"
            ></v-select>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Price"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="items"
                  label="Currency"
                  single-line
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <div class="d-flex align-center">
              <div>
                <span style="color:#727070">IBA Payment</span>
              </div>
              <div class="ml-5">
                <v-radio-group v-model="radios" class="d-flex" row>
                  <v-radio value="Google">
                    <template v-slot:label>
                      <div class="mt-2" style="color:#727070">Yes</div>
                    </template>
                  </v-radio>
                  <v-radio value="Duckduckgo">
                    <template v-slot:label>
                      <div class="mt-2" style="color:#727070">No</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>
            <div class="d-flex">
              <div>
                <span style="color:#727070">Auto Graduate</span>
              </div>
              <div class="ml-4 mt-0 pt-0">
                <v-radio-group
                  v-model="radiosauto"
                  class="d-flex mt-0 pt-0"
                  row
                >
                  <v-radio value="yes">
                    <template v-slot:label>
                      <div class=""> <span style="color:#727070">Yes</span></div>
                    </template>
                  </v-radio>
                  <v-radio value="no">
                    <template v-slot:label>
                      <div class=""><span style="color:#727070">No </span></div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>
            <v-text-field
              label="Payment Link (Optional)"
              single-line
              dense
              hide-details
            ></v-text-field>
          </div>
          <div class="my-5 px-10"><b>Dates information</b></div>
          <div>
            <div class="pa-1 px-10" style="background-color: white">
              <v-select
                :items="items"
                label="Choose time zone"
                single-line
                hide-details
                class="my-5"
              ></v-select>
              <!----------------------------Date time section---------------------------------------------->
              <div>
                <v-row class="mt-5 mb-3">
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="dateAt"
                      v-model="dateAt"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Date at"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateAt = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dateAt.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="time1"
                      v-model="time1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="StartTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="StartTime"
                          label="Time Start"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="time1"
                        v-model="StartTime"
                        full-width
                        @click:minute="$refs.time1.save(StartTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="time2"
                      v-model="time2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="EndTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="EndTime"
                          label="Time End"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="time2"
                        v-model="EndTime"
                        full-width
                        @click:minute="$refs.time2.save(EndTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row
                  class="mt-5 mb-3"
                  v-for="(div, index) in divs"
                  :key="div.id"
                  :div="(div = index)"
                >
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="dateAt"
                      v-model="dateAt"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label="Date at"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dateAt = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dateAt.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="time1"
                      v-model="time1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="StartTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="StartTime"
                          label="Time Start"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="time1"
                        v-model="StartTime"
                        full-width
                        @click:minute="$refs.time1.save(StartTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-menu
                      ref="time2"
                      v-model="time2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="EndTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="EndTime"
                          label="Time End"
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="time2"
                        v-model="EndTime"
                        full-width
                        @click:minute="$refs.time2.save(EndTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <div class="d-flex justify-space-between pb-7 pt-3">
                  <div>
                    <span class="primary--text" @click="addRow"
                      >Add new Day</span
                    >
                  </div>
                  <div>
                    <span class="red--text" @click="deleteRow(index)"
                      >Delete Day</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <v-textarea
              name="input-7-1"
              class="my-5 px-10"
              label="Discount Note  (optional)"
              value="Discount Note  (optional)"
              counter="300"
            ></v-textarea>
            <v-textarea
              name="input-7-1"
              class="my- px-10"
              label="Other Info  (optional)"
              value="Other Info  (optional)"
              counter="300"
            ></v-textarea>
            <v-textarea
              name="input-7-1"
              class="my-5 px-10"
              label="Waiver (optional)"
              value="Waiver (optional)"
              counter="300"
            ></v-textarea>
            <v-textarea
              name="input-7-1"
              class="my-5 px-10"
              label="Agreement for coordinator "
              value="Agreement for coordinator "
              counter="300"
            ></v-textarea>
          </div>
        </div>
        <div class="mt-9 px-10" v-if="Presential">
          <v-text-field
            label="URL Link"
            dense
            single-line
            hide-details
          ></v-text-field>
          <v-select
            v-model="Modality"
            single-line
            dense
            class="my-8"
            hide-details
            :items="ModalityList"
            label="Modality"
            multiple
            persistent-hint
          ></v-select>
          <v-select
            v-model="EventType"
            single-line
            dense
            hide-details
            :items="EventTypeList"
            label="Modality"
            multiple
            persistent-hint
          ></v-select>
        </div>
      </div>
    </v-card>
    <div class="d-flex justify-end px-10 my-2">
      <v-btn color="transparent" depressed class="mr-4" @click="close"
        ><span class="text_style">Cancel</span></v-btn
      >
      <v-btn class="px-14" depressed color="primary" @click="close"
        ><span class="text_style">Save</span></v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AddSeminarComponent",
  props: ["AddSeminarDialog"],
  data() {
    return {
      div: 0,
      divs: [],
      Presential: false,
      IBAPaymentRadio: null,
      radiosauto: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateAt: false,
      StartTime: null,
      time1: false,
      EndTime: null,
      time2: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addRow() {
      this.divs.push({
        div: this.div,
      }); 
    },
    deleteRow(index) {
      this.divs.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.slide-toggle {
  position: relative;
  background-color: #e2e3ed;
  border-radius: 200px;
  width: 100%;
  margin: auto;
}
.boxes {
  width: 50%;
  height: 47px;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  text-align: center;
  border-radius: 200px;
}
.box-active {
  position: absolute;
  width: 50%;
  height: 41px;
  top: 3px;
  left: 1%;
  right: 0;
  z-index: 1;
  background-color: white;

  border-radius: 200px;
}

.presential-active {
  right: 0;
  left: 49% !important;
}
</style>
